// extracted by mini-css-extract-plugin
module.exports = {"button":"a2c79c7e7d--button--OG_GQ"};